export enum ESpecialization {
  None = 255,
  Harvester = 0,
  Mechanic = 1,
  Mirage = 2, // Stealth
  Medic = 3,
  Engineer = 4
}
